export default __webpack_public_path__ + "static/media/gmail.3c734ec1.png";